// src/pages/Home.jsx
import React from 'react';
// composants
import Title from '../components/Title/Title';
import SimpleTitle from '../components/Title/SimpleTitle';
import Content from '../components/content/content';
import ContentSlider from '../components/content/content-slider.jsx';
import ContentText from '../components/content/content-text.jsx';
import Projects from '../components/Projects/project.jsx';
import Skills from '../components/Projects/Skills.jsx';
import Button from '../components/buttons/button';
// contenus
import parcours from '../assets/content/parcours.json';
import realisation from '../assets/content/realisations.json';
import pgm from '../assets/content/projets/pgm.json';


const Bibliotheque = () => {


  
  return (
    <>
    
      {/* Bloc Parcours */}
      <div className="parcours bloc">
        <Title title={parcours.title} variant={parcours.home.variant}></Title>
        <Content content={parcours.home.content} image={{thumb: parcours.home.image,hd: parcours.home.image}} alt={parcours.home.alt} cote={"left"}></Content>
        <SimpleTitle title="Développement" variant="green" position="left" />
        <SimpleTitle title="Graphisme, Dev" variant="green" position="right" />
        <SimpleTitle title="Communication" variant="pink" position="center" />
        <SimpleTitle title="Graphisme, Communication, Gestion de projet" variant="purple" position="center" />
        <Content content={parcours.home.content} image={{thumb: parcours.home.image,hd: parcours.home.image}} alt={parcours.home.alt} cote={"right"}></Content>
      </div>
      
      {/* Bloc Réalisation */}
      <div className="realisations bloc">
        <Title title={realisation.title} variant={realisation.home.variant}></Title>
        <div className={`realisations-grid ${realisation.home.variant}`}>
          {realisation.realisations
            .filter(item => item.home === true)
            .map((item, index) => {
              
              return (
                <Projects
                  key={index}
                  image={item.image}
                  alt={item.alt}
                  nom_real={item.title}
                  description={item.description}
                  link={item.link}
                />
              );
            })}
        </div>

        <ContentSlider
          content={parcours.home.content}
          images={pgm.slider1}
          cote="left"
        />

        <ContentSlider
          content={parcours.home.content}
          images={pgm.slider1}
          cote="right"
        />

        <ContentText content={parcours.home.content} />
        
       
          <Button text="Voir les réalisations" link ="/projects" cote="right"></Button>
          <Button text="Voir les réalisations" link ="/projects" cote="left"></Button>
          <Button text="Voir les réalisations" link ="/projects"  cote="center"></Button>

        
      </div>

      <div className='bloc'>
            <div className='skills-grid'>
                {pgm.technologies.map((tech, index) => (
                <Skills
                    image={tech.image}
                    alt={tech.alt}
                    competence={tech.name}
                    centered={tech.bool}
                />
            ))}
            </div>
        </div>
    </>
  );
};

export default Bibliotheque;